import React from "react";
import { compose } from "redux";
import {
  Container,
  Text,
  withStyles,
  withBreakpoint,
  ChooseWrapper
} from "components/common";
// import tomocard from "assets/green_tomo_card.svg";
import tomocard from "assets/tomo_vert_card.png";
import formatCurrency from "utils/formatCurrency";

const CurrentBalance = ({ user, breakpointContext: { isBelow } }) => (
  <ChooseWrapper
    wrapper={
      isBelow("md") ? <div /> : <Container className="w-full justify-center" />
    }
  >
    <div className="flex flex-col md:flex-row pt-1 pb-2 md:py-0">
      <div className="flex mt-2 md:mt-0 balance-card-m md:balance-card-d mx-auto md:mx-0 md:pl-1 mb-5 md:mb-0">
        <div className="md:block">
          <img
            alt="tomo-card"
            className="md:w-8/12 w-full mx-auto"
            src={tomocard}
          />
        </div>
      </div>
      <div className="flex flex-col justify-center md:pl-6 md:text-left text-center">
        <Text className="pb-1 text-2xl md:text-xl" title>
          Current Balance
        </Text>
        <Text size="text-3xl" weight="font-light">
          {`${
            user.credit
              ? `${formatCurrency((-user.payment_due_balance || 0).toFixed(2))}`
              : "N/A"
          }`}
        </Text>
      </div>
    </div>
  </ChooseWrapper>
);

export default compose(withStyles, withBreakpoint)(CurrentBalance);
